class Menu {
    private $language       =   $("#language-select");

    public constructor() {
        this.$language.on('change', this.onLangChange.bind(this));
        $("a").on('click', (e) => {
            const url = $(e.currentTarget).attr('href');
            const dataToggle = $(e.currentTarget).attr('data-toggle');

            if (typeof dataToggle !== "undefined" || url.substr(0,1) !== '#' || !$(url).length || $(url).is(':hidden'))
                return;


            $("html, body").animate({scrollTop: $(url).offset().top}, 400);
        });
    }

    private onLangChange(e) {
        console.log("Language changed!");
        let opt = this.$language.find(":selected");
        $("#page-busy").show();
        window.location.href = opt.attr("data-url");
    }
}

export default Menu;